//created by sudip
import { HeroMetricCard } from "./HeroMetricCard";

interface HeroMetricsProps {
    accent: string;
}

const metrics = [

    {
        title: "AI Agents",
        value: "128",
        change: "+24%",
    },

    {
        title: "Workflow Automation",
        value: "98%",
        change: "Healthy",
    },

    {
        title: "Enterprise Systems",
        value: "42",
        change: "Connected",
    },

];

export function HeroMetrics({

    accent,

}: HeroMetricsProps) {

    return (

        <div className="grid gap-4 md:grid-cols-3">

            {metrics.map((metric, index) => (

                <HeroMetricCard
                    key={metric.title}
                    title={metric.title}
                    value={metric.value}
                    change={metric.change}
                    accent={accent}
                    delay={0.15 * index}
                />

            ))}

        </div>

    );

}